/**
 * @description
 * Parse expectedServiceDays to a string with unit.
 * @example
 * input: { expectedServiceDays: 5, maxServiceDays: 7 }
 * output: { parsedExpectedServiceDays: "5 天", daysUnit: "天", expectedServiceDays: 5 }
 */
export const getParsedExpectedServiceDays = ({ expectedServiceDays, maxServiceDays, }) => {
    // #NOTES
    // We reset the daysUnit to '天' when 'maxServiceDays' is null,
    // because any integer is greater than or equal to null,
    // so that the daysUnit will always be '天以上',
    // which might provide misleading information to users.
    let daysUnit = '';
    let parsedExpectedServiceDays = '';
    if (!expectedServiceDays || maxServiceDays === null) {
        daysUnit = '天';
        parsedExpectedServiceDays = '';
    }
    else {
        daysUnit = expectedServiceDays >= maxServiceDays ? '天以上' : '天';
        parsedExpectedServiceDays = `${expectedServiceDays} ${daysUnit}`;
    }
    return { parsedExpectedServiceDays, daysUnit, expectedServiceDays };
};
/**
 * @example
 * input: { string: '1234567890' }
 * output: '1234567890'
 * @example
 * input: { string: '!\123' }
 * output: '123'
 */
export const getStringWithoutSpecialCharacters = ({ string }) => {
    const stringWithoutSpecialCharacters = string.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, '');
    return stringWithoutSpecialCharacters;
};
